import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrollt bei Routenwechsel nach oben, oder springt zu Hash-Anker falls vorhanden.
// Wartet aktiv bis das Ziel-Element im DOM ist (max. 60 Versuche à 50ms = 3 s).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      let tries = 0;
      const maxTries = 60;
      const findAndScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        return false;
      };

      if (findAndScroll()) return;
      const iv = setInterval(() => {
        tries += 1;
        if (findAndScroll() || tries >= maxTries) clearInterval(iv);
      }, 50);
      return () => clearInterval(iv);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
